import { typedQueryClient, useTypedQuery } from "hooks";
import { DMSv3CustomQueriesQueryKeys } from "modules/DMSv3/CustomQueries/queryKeys";
import { DMSV3_CUSTOM_QUERIES_STORAGE_KEYS } from "modules/DMSv3/CustomQueries/storageKeys";
import { getPreference, setPreference } from "utils/common";

import type { CustomQueriesFilters } from "modules/DMSv3/CustomQueries/queryKeys";

const getInitialFilters = (): CustomQueriesFilters => ({
  dealer_location_id: getPreference(DMSV3_CUSTOM_QUERIES_STORAGE_KEYS.LocationPreference, null),
  page: 1
});

export const useCustomQueriesFilters = () => useTypedQuery({ queryKey: DMSv3CustomQueriesQueryKeys.filters, initialData: getInitialFilters });

export const setCustomQueriesFilters = (filters: CustomQueriesFilters) => {
  setPreference(DMSV3_CUSTOM_QUERIES_STORAGE_KEYS.LocationPreference, filters.dealer_location_id);

  typedQueryClient.setQueryData(DMSv3CustomQueriesQueryKeys.filters, filters);
};
